import type { NVXPermission } from './roles';

/**
 * Check if user has ANY of the required permissions
 */
export function hasAnyPermission(
  userPermissions: NVXPermission[],
  requiredPermissions: NVXPermission[]
): boolean {
  return requiredPermissions.some((perm) => userPermissions.includes(perm));
}

/**
 * Check if user has ALL of the required permissions
 */
export function hasAllPermissions(
  userPermissions: NVXPermission[],
  requiredPermissions: NVXPermission[]
): boolean {
  return requiredPermissions.every((perm) => userPermissions.includes(perm));
}

/**
 * Guard against open redirects: only allow same-origin relative paths.
 * Resolving via URL and comparing origins (rather than string-matching)
 * also catches the `/\evil.com` backslash-normalization bypass.
 */
export function isSameOriginPath(value: string | null | undefined): value is string {
  if (!value || !value.startsWith('/')) return false;
  try {
    return new URL(value, window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
}
